<!-- 基木鱼用户 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="screen-box">
				<div class="screen-label">投放日期</div>
				<a-range-picker style="width:240px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">点击日期</div>
				<a-range-picker style="width:240px;" @change="onChangeDateB" :allowClear="false"
				:locale="locale" allowClear 
				:value="[show_click_start,show_click_end]" />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广链接ID</div>
				<a-input v-model="r_promote_link_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">账户名称</div>
				<a-input v-model="r_adUcName" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">单元ID</div>
				<a-input v-model="r_unitId" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">创意ID</div>
				<a-input v-model="r_creativeId" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			
			<div class="screen-box">
				<div class="screen-label">组件方案名称</div>
				<a-input v-model="r_solutionName" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">微信ID</div>
				<a-input v-model="r_accountName" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">IP</div>
				<a-input v-model="r_ip" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">省份</div>
				<a-input v-model="r_province" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>

			<div class="screen-box">
				<div class="screen-label">城市</div>
				<a-input v-model="r_city" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>

		
			
			<div class="screen-box">
				<div class="screen-label">是否回传</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeD" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">已充值</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeE" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" >
					ID
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[1].width + 'px'}" >
					线索ID
				</div>
				
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > 1" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.type != 'click_time' && z_tem.type != 'city' && z_tem.type != 'has_pay' && z_tem.type != 'cz'" 
				class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- 点击时间 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'click_time'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.click_time | clickDate}}
				</div>
				<!-- 地区 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'city'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.province}} {{item.city}}
				</div>
				<!-- 是否充值 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'has_pay'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.has_pay == 0 ?'否':'是'}}
				</div>
				<!-- 操作 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'cz'" class="table-td-cell" :style="{'width': rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.has_pay == 1" @click="HcTdTable(item,0)" style="color: #62a8ea;cursor: pointer;">手动回传百度</div>
					<!-- <div @click="HcTdTable(item,0)" style="color: #62a8ea;cursor: pointer;margin-top: 7px;">联调头条事件</div> -->
				</div>
			</template>
			
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': body_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 41px;">
			<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': body_width - 60 + 'px',}">
				<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" :showTotal="(total, range) => `共 ${total} 条`" @change="paginationChange" hideOnSinglePage/>
			</div>
		</div>
	</div>
	
	<!-- 手动回传 -->
	<a-modal :visible="hc_visible" title="确认要回传？" @ok="hcOk" @cancel="hcCancel" 
	cancelText="取消" okText="确认" :confirmLoading="hc_confirm_loading">
	    <div>ID：{{hc_id}}</div>
	</a-modal>
	
	<!-- 自定义回传 -->
	<!-- <a-modal :visible="hc_Zdy_visible" title="自定义回传" @ok="hcZdyOk" @cancel="hcZdyCancel"
	cancelText="取消" okText="确认" :confirmLoading="hc_Zdy_loading">
		<div class="form-cell-box">
			<div class="class-title">落地页用户类型</div>
			<a-select
				:value="h_report_id_type"
			    style="width: 290px"
			    placeholder="请选择"
			    @change="handleChangeH"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option value="0">自建落地页</a-select-option>
				<a-select-option value="1">基木鱼</a-select-option>
				<a-select-option value="3">巨量点击检测</a-select-option>
			</a-select>
		</div>
		
	    <div class="form-cell-box">
	    	<div class="class-title">落地页用户ID</div>
	    	<a-input v-model="h_report_id" placeholder="前往对应落地页用户类型页面复制ID" style="width: 290px;"  />
	    </div>
	</a-modal> -->
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { putDataMenu, LdJmyList, LdJmyReport, orderGzhCustomReport,  } from '@/request/api'
export default {
	name: 'orderGzh_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
			}, 
			click_start_date: '', // 点击日期
			click_end_date: '', // 点击日期
			show_click_start: '', // 点击日期开始
			show_click_end: '', // 点击日期结束
			
			
			is_admin: false, // 为true表示 超级管理员
			is_super: false, // 为true表示放管理
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"线索ID", width:120, type:"clueId", },
				{title:"基木鱼页面ID", width:120, type:"pageId", },
				{title:"基木鱼页面名称", width:180, type:"pageName", },
				{title:"基木鱼站点ID", width:120, type:"siteId", },
				{title:"基木鱼站点URL", width:160, type:"siteUrl", },
				{title:"组件方案ID", width:100, type:"solutionId", },
				{title:"组件方案名称", width:120, type:"solutionName", },
				{title:"微信ID", width:100, type:"accountName", },
				{title:"投放日期", width:120, type:"datekey", },
				{title:"点击时间", width:150, type:"click_time", },
				{title:"IP", width:130, type:"ip", },
				{title:"地区", width:120, type:"city", },
				{title:"推广链接ID", width:120, type:"promote_link_id", },
				{title:"推广账户", width:120, type:"adUcName", },
				{title:"计划ID", width:120, type:"planId", },
				{title:"单元ID", width:120, type:"unitId", },
				{title:"创意ID", width:120, type:"creativeId", },
				{title:"BdVid", width:150, type:"bdVid", },
				{title:"是否充值", width:100, type:"has_pay", },
				{title:"回传次数", width:100, type:"report_count", },
				
				{title:"操作", width:160, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			search_button_loading: false, // 搜索按钮的加载状态
			sticky_index: 1,
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_adUcName: "", // 账户名称
			r_unitId: "", // 单元ID
			r_creativeId: "", // 创意ID,
			r_promote_link_id: null, // 推广链接ID
			r_solutionName: "", // 组件方案名称
			r_accountName: "", // 微信ID
			r_ip: "", // ip
			r_province: "", // 省份
			r_city: "", // 城市
			r_is_report: "", // 是否回传 0为否。1为是
			r_has_pay: "", // 已充值 0为否。1为是
			
			
			hc_id: "", // 手动回传id
			hc_visible: false, // 手动回传弹窗
			hc_confirm_loading: false, 
			hc_Zdy_visible: false, 
			hc_Zdy_loading: false,
			h_report_id: "", // 落地页用户ID
			h_report_id_type: undefined, // 落地页用户类型
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		
		// 获取7天前日期
		// that.startTime = this.$getBeforeDay(6)
		
		// 获取当前日期
		that.endTime = this.$getThisDay()
		that.startTime = this.$getThisDay()


		// 搜索
		that.searchButton()
			
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 点击日期
		onChangeDateB(date, dateString){
			console.log('点击日期',date, dateString);
			if(dateString[0]){
				this.show_click_start = this.moment(dateString[0], this.dateFormat) || '' // 点击日期开始
				this.show_click_end = this.moment(dateString[1], this.dateFormat) || '' // 点击日期结束
			}
			else {
				this.show_click_start =  '' // 点击日期开始
				this.show_click_end =  '' // 点击日期结束
			}
			
			
			this.click_start_date = dateString[0]
			this.click_end_date = dateString[1]
		},
		
		handleChangeD(e){ // 是否回传
			console.log(e);
			this.r_is_report = e
		},
		handleChangeE(e){ // 是否已充值 0为否。1为是
			console.log(e);
			this.r_has_pay = e
		},
		
		handleChangeH(e){ // 落地页用户类型
			this.h_report_id_type = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			let s_date,e_date
			if(that.click_start_date){
				s_date = that.click_start_date + ' 00:00:00'
				e_date = that.click_end_date + ' 23:59:59'
			}
			else {
				s_date = ""
				e_date = ""
			}
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			
			LdJmyList({
				limit: that.r_limit,
				page: that.r_page,
				start_date_key: that.startTime.replace(/-/g, ''),
				end_date_key: that.endTime.replace(/-/g, ''),
				start_click_time: s_date, // 点击日期开始
				end_click_time: e_date, // 点击日期结束
				
				adUcName: that.r_adUcName, // 账户名称
				unitId: that.r_unitId, // 单元ID
				creativeId: that.r_creativeId, // 创意ID,
				promote_link_id: that.r_promote_link_id, // 推广链接ID
				solutionName: that.r_solutionName, // 组件方案名称
				accountName: that.r_accountName, // 微信ID
				ip: that.r_ip, // ip
				
				province: that.r_province, // 省份
				city: that.r_city, // 城市
				is_report: that.r_is_report, // 是否回传 0为否。1为是
				has_pay: that.r_has_pay, // 已充值 0为否。1为是
				
				
			}).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					// that.is_super = res.data.data.is_super // 是否是投放管理员
					
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		
		// 回传操作
		HcTdTable(e,type){
			if(type == 0){ // 手动回传头条
				this.hc_id = e.id
				this.hc_visible = true
			}
			else if(type == 1){ // 自定义回传
				this.hc_id = e.id
				this.hc_Zdy_visible = true
				
			}
		},
		// 手动回传弹窗确认按钮
		hcOk(){
			let that = this
			that.hc_confirm_loading = true
			LdJmyReport({
				id: that.hc_id
			}).then(res=>{
				console.log("回传",res);
				that.hc_confirm_loading = false
				
				if(res.data.code == 0){
					that.hcCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
			})
			.catch(err=>{
				that.hc_confirm_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcCancel(){
			if(this.hc_confirm_loading){
				return
			}
			this.hc_visible = false
		},
		// 自定义回传
		hcZdyOk(){
			let that = this
			if(!that.h_report_id_type){
				that.$message.warning('落地页用户类型不能为空');
				return
			}
			else if(!that.h_report_id){
				that.$message.warning('落地页用户ID不能为空');
				return
			}
			
			that.hc_Zdy_loading = true
			orderGzhCustomReport({
				order_id: that.hc_id,
				report_id: that.h_report_id,
				report_id_type: that.h_report_id_type,
			}).then(res=>{
				console.log("自定义回传",res);
				that.hc_Zdy_loading = false
				
				if(res.data.code == 0){
					that.hcZdyCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
				
			})
			.catch(err=>{
				that.hc_Zdy_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcZdyCancel(){
			if(this.hc_Zdy_loading){
				return
			}
			this.h_report_id = ""
			this.h_report_id_type = undefined
			this.hc_Zdy_visible = false
		},
		
		
	},
	filters: {
		clickDate(value){
			let ttt = value
			// console.log(value);
			//时间戳转化成时间格式
			function timeFormat(value) {
			    //value是整数，否则要parseInt转换,不会出现少个0的情况
			    //如果value是10位数的需要 value* 1000
			    var time = new Date(value* 1000);
				// console.log('time',time);
			    var year = time.getFullYear();
				// console.log('time',time);
			    var month = time.getMonth() + 1;
			    var date = time.getDate();
			    var hours = time.getHours();
			    var minutes = time.getMinutes();
			    var seconds = time.getSeconds();
			    return year + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
			}
			function add0(m) {
			    return m < 10 ? '0' + m : m
			};
			// console.log(timeFormat(value));
			return timeFormat(value)
		}
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

.table-td-cell {
	font-size: 13px;
}
</style>